import awsExports from './aws-exports';
import outputs from './amplify_outputs.json';

/**
 * Resolves the Amplify configuration used by `Amplify.configure(...)`.
 *
 * During the Gen 1 -> Gen 2 migration two config sources can exist:
 *  - `amplify_outputs.json` (Gen 2, generated by `ampx sandbox`/pipeline) — preferred.
 *  - `aws-exports.js` (Gen 1, generated by `amplify env checkout`) — fallback.
 *
 * `amplify_outputs.json` may be an empty `{}` placeholder on machines that only
 * use the Gen 1 flow (see scripts/ensure-amplify-outputs.js), so we only treat
 * it as valid when it actually contains an auth block.
 *
 * In both cases the OAuth redirect URIs are rewritten to the current origin so
 * hosted-UI / social sign-in works on localhost and every deployed domain.
 */

const clone = (value) => JSON.parse(JSON.stringify(value));

const currentOrigin =
  typeof window !== 'undefined' && window.location ? `${window.location.origin}/` : undefined;

const hasGen2Outputs = Boolean(outputs && outputs.auth && outputs.auth.user_pool_id);

const buildGen2Config = () => {
  const config = clone(outputs);
  if (currentOrigin && config.auth && config.auth.oauth) {
    config.auth.oauth.redirect_sign_in_uri = [currentOrigin];
    config.auth.oauth.redirect_sign_out_uri = [currentOrigin];
  }
  return config;
};

const buildGen1Config = () => {
  const config = clone(awsExports);

  // Preserve the legacy per-environment pool switching (staging hostnames reuse
  // other pools). Only relevant to the Gen 1 aws-exports flow.
  if (config.aws_user_pools_id === 'eu-west-2_NeojTq9f0') {
    // Stage env signs in through the dev user pool.
    config.aws_cognito_identity_pool_id = 'eu-west-2:1445f8d0-77bd-438b-97ec-76a3b195b5da';
    config.aws_user_pools_id = 'eu-west-2_p3L38NXoz';
    config.aws_user_pools_web_client_id = '1csrmd2iunqcjjb2uqgcldg0tq';
  } else if (config.aws_user_pools_id === 'eu-west-2_SgLIXwGTA') {
    // Staging-two env signs in through the prodamp user pool.
    config.aws_cognito_identity_pool_id = 'eu-west-2:e8ca2f76-1ffb-4220-b353-ba79719908c6';
    config.aws_user_pools_id = 'eu-west-2_j5gGmzsA0';
    config.aws_user_pools_web_client_id = '5cceagnrppj0ma9vdffgunk5uu';
    config.oauth.domain = 'cyf-prodamp.auth.eu-west-2.amazoncognito.com';
  }

  if (currentOrigin && config.oauth) {
    config.oauth.redirectSignIn = currentOrigin;
    config.oauth.redirectSignOut = currentOrigin;
  }
  return config;
};

const amplifyConfig = hasGen2Outputs ? buildGen2Config() : buildGen1Config();

export const usingGen2Auth = hasGen2Outputs;

export default amplifyConfig;
